import React from "react";
import {Link} from "react-router-dom";
import servicepic1 from '../../images/1.jpg';
import servicepic2 from '../../images/2.jpg';
import servicepic3 from '../../images/customize.jpg';

function CardsServices() {


return(



    <section className="section  boder-top" >
<div className="container">
   <div className="row">

    <div className="col-md-12 mb-4 text-center">
     <h3 className="main-heading "> خدمات شرکت </h3>
     <div className="underline mx-auto"> </div>
    </div>





    <div className="col-md-4 ">
    <div className="card shadow"></div>
    <img src={servicepic1}  width="200" height="250"   className="w-100 border-bottom" alt="services" />
    <div className="card-body"></div>
    <h6 className="mt-2">پشتیبانی</h6>
    <div className="underline"></div>
    <p>
    نرم‌افزار حسابداری راینو با ارائه خدمات پشتیبانی عالی، به کاربران این امکان را می‌دهد که هرگونه سوال یا مشکل خود را به راحتی حل کنند. تیم پشتیبانی راینو متشکل از متخصصان مجرب، آماده است تا در تمامی مراحل استفاده از نرم‌افزار به شما کمک کند. از نصب و راه‌اندازی گرفته تا رفع مشکلات فنی و ارائه مشاوره‌های مالی، خدمات پشتیبانی راینو همواره در دسترس شماست. با اعتماد به راینو، از تجربه‌ای راحت و بی‌دغدغه در مدیریت مالی خود لذت ببرید!       
    </p>
    </div>





    <div className="col-md-4 ">
    <div className="card shadow"></div>
    <img src={servicepic2}  width="200" height="250"   className="w-100 border-bottom" alt="services" />
    <div className="card-body"></div>
    <h6 className="mt-2">بروزرسانی های ماهیانه</h6>
    <div className="underline"></div>
    <p>
    نرم‌افزار حسابداری راینو با ارائه خدمات به‌روزرسانی ماهیانه، همواره از جدیدترین قابلیت‌ها و تغییرات بازار برخوردار است. این به‌روزرسانی‌ها شامل بهبودهای عملکرد، رفع اشکالات و افزودن ویژگی‌های جدید می‌شود که به کاربران کمک می‌کند تا به‌راحتی و با اطمینان بیشتری از نرم‌افزار استفاده کنند. با راینو، همیشه در خط مقدم تکنولوژی‌های حسابداری باشید و از یک تجربه مالی به‌روز و کارآمد لذت ببرید!       
    </p>
    </div>




    <div className="col-md-4 ">
    <div className="card shadow"></div>
    <img src={servicepic3}  width="200" height="250"   className="w-100 border-bottom" alt="services" />
    <div className="card-body"></div>
    <h6  className="mt-2">خصوصی سازی</h6>
    <div className="underline"></div>
    <p>
    رم‌افزار حسابداری راینو با قابلیت خصوصی‌سازی، به سازمان‌ها این امکان را می‌دهد که سیستم مالی خود را مطابق با نیازها و الزامات خاص خود تنظیم کنند. این ویژگی به کاربران کمک می‌کند تا فرآیندها و گزارش‌ها را به‌صورت شخصی‌سازی شده و متناسب با ساختار سازمانی خود مدیریت کنند. با راینو، می‌توانید به راحتی نرم‌افزار را به گونه‌ای تنظیم کنید که بهترین عملکرد را برای کسب‌وکار شما داشته باشد و به‌این‌ترتیب، بهره‌وری و کارایی خود را افزایش دهید.       
    </p>
    </div>





   </div>
</div>

</section>



)


}


export default CardsServices;